import { gql } from '@apollo/client';

export const activateBusinessPartner = gql`
  mutation activateBusinessPartner($businessPartnerId: String!) {
    salesforce {
      activateBusinessPartner(businessPartnerId: $businessPartnerId)
    }
  }
`;

export const deactivateBusinessPartner = gql`
  mutation deactivateBusinessPartner($businessPartnerId: String!) {
    salesforce {
      deactivateBusinessPartner(businessPartnerId: $businessPartnerId)
    }
  }
`;

export const activateBusinessPartnerPlans = gql`
  mutation activateBusinessPartnerPlans(
    $businessPartnerId: String!
    $businesspartnerPlans: [String!]!
  ) {
    salesforce {
      activateBusinessPartnerPlans(
        businessPartnerId: $businessPartnerId
        businesspartnerPlans: $businesspartnerPlans
      )
    }
  }
`;

export const deactivateBusinessPartnerPlans = gql`
  mutation deactivateBusinessPartnerPlans(
    $businessPartnerId: String!
    $businesspartnerPlans: [String!]!
  ) {
    salesforce {
      deactivateBusinessPartnerPlans(
        businessPartnerId: $businessPartnerId
        businesspartnerPlans: $businesspartnerPlans
      )
    }
  }
`;
